"use client";

import { useRef } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const caseStudyRoutes: Record<string, string> = {
  "Farmacêutica": "/PharmaceuticalCaseStudyPage",
  "Pasta, Papel & Tissue": "/PulpPaperTissueCaseStudyPage",
  "Aço & Metais": "/SteelAndMetalsCaseStudyPage",
  "Transportes": "/TransportationCaseStudyPage",
  "Fabrico Automóvel": "/VehicleManufacturingCaseStudyPage",
  "Outras": "/OtherIndustriesCaseStudyPage"
};
const stories = [{
  area: "PHARMACEUTICAL MANUFACTURING",
  title: "Farmacêutica\xA0",
  summary: "As operações de pulverização de elevada precisão são fundamentais para a qualidade, a segurança e o potencial de rentabilidade dos produtos farmacêuticos e de dispositivos médicos. Os principais fabricantes e investigadores destes sectores têm colaborado com a Spraying Systems Co. no desenvolvimento de novas soluções de pulverização que otimizam os processos e ajudam a atingir os objetivos empresariais.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.37.21.png?v=773b99ufwrg",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.37.21.png?v=dvt9ptygt1-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.37.21.png?v=zdy2bng0n6-wvc-sizes",
  alt: "Sistema de pulverização industrial em linha de montagem automotiva"
}, {
  area: "PULP, PAPER & TISSUE",
  title: "Pasta, Papel & Tissue\xA0",
  summary: "As unidades de produção de papel, embalagens e tissue confiam na Spraying Systems Co. para tecnologia que optimiza as operações de pulverização em todo o processo de fabrico. Disponibilizamos mais produtos para este sector do que qualquer outro fornecedor — desde bicos anti-entupimento até sistemas automatizados completos — concebidos para reduzir o consumo de água, os tempos de paragem e o desperdício, melhorando simultaneamente a qualidade e a eficiência.",
  partner: "Spraying Systems Co.®\xA0",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.18.png?v=mz79jxl5x18",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.18.png?v=2njos7qco2t-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.18.png?v=e0xzx0zfzja-wvc-sizes",
  alt: "Equipamento de lavagem de tanques em aço inoxidável"
}, {
  area: "STEEL & METALS",
  title: "Aço & Metais",
  summary: "Os fabricantes das indústrias do aço, alumínio e transformação de metais confiam na tecnologia de pulverização da Spraying Systems Co. para as suas operações quotidianas. Os nossos bicos de pulverização, cabeçotes, lanças e sistemas completos permitem otimizar as operações, reduzindo o consumo de água e as necessidades de manutenção. Disponibilizamos ainda serviços avançados de testes e modelação para assegurar o desempenho de pulverização pretendido.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.38.png?v=915cnsyrxto",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.38.png?v=mpgt3yym6cm-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.38.png?v=ku901c2kgkp-wvc-sizes",
  alt: "Torre de lavagem de gases com sistema de pulverização"
}, {
  area: "TRANSPORTATION",
  title: "Transportes",
  summary: "A Spraying Systems Co. disponibiliza soluções de pulverização críticas para aplicações de transporte — terrestres e marítimas. Os nossos bicos de limpeza de tanques e sistemas automatizados são reconhecidos pela limpeza rápida e eficaz de cisternas, vagões e embarcações, reduzindo o uso de água e de químicos e aumentando a produtividade.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.58.png?v=7dswpg43b2r",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.58.png?v=1cl05ofn4y8-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.39.58.png?v=krmqx1zzi8d-wvc-sizes",
  alt: "Sistema de nebulização em estufa agrícola moderna"
}, {
  area: "VEHICLE MANUFACTURING",
  title: "Fabrico Automóvel \xA0",
  summary: "A Spraying Systems Co. oferece tecnologia de pulverização inovadora e soluções personalizadas, especificamente concebidas para as exigências do fabrico de automóveis, camiões, comboios e outros veículos. Ajudamos a melhorar a qualidade do produto, aumentar a eficiência dos processos, reduzir o desperdício e apoiar as suas iniciativas de sustentabilidade em todas as fases da produção.",
  partner: "Spraying Systems Co.®",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.40.10.png?v=f18q8t3xl5",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.40.10.png?v=g340e5fn5v-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/07/Captura-de-ecra-2026-07-20-as-18.40.10.png?v=kj8fbdqrq-wvc-sizes",
  alt: "Processo de arrefecimento de metal fundido com bicos de pulverização"
}, {
  area: "OTHERS",
  title: "Outras",
  summary: "Além das indústrias mencionadas, oferecemos soluções completas para uma grande diversidade de setores industriais, com equipamentos e sistemas dimensionados para diferentes desafios de produção. Para conhecer outras aplicações e soluções disponíveis, clique abaixo e saiba mais.",
  partner: "Spraying Systems Co.®",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/revestimento_papel.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/revestimento_papel.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/revestimento_papel.png-wvc-sizes",
  alt: "Máquina de papel com sistema de revestimento por pulverização"
}];
export default function Success() {
  const container = useRef<HTMLElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".story-header", {
        y: 24
      });
      gsap.to(".story-header", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".story-card", {
        y: 24
      });
      gsap.to(".story-card", {
        opacity: 1,
        y: 0,
        duration: 0.64,
        ease: "power3.out",
        stagger: 0.12,
        scrollTrigger: {
          trigger: ".story-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".story-header", ".story-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31375" id="industrialsuccesscases" ref={container} className="bg-background text-foreground py-24 md:py-44">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        

        <div className="story-grid mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {stories.map((story, i) => <article key={i} data-index={i} className="story-card group relative flex flex-col overflow-hidden rounded-2xl border transition-all duration-[320ms] hover:-translate-y-1" style={{
          opacity: 0,
          backgroundColor: "var(--card)",
          borderColor: "var(--border)"
        }} onMouseEnter={e => {
          e.currentTarget.style.borderColor = "var(--primary)";
          e.currentTarget.style.boxShadow = "var(--shadow-md)";
        }} onMouseLeave={e => {
          e.currentTarget.style.borderColor = "var(--border)";
          e.currentTarget.style.boxShadow = "none";
        }}>
              <div className="relative overflow-hidden" style={{
            aspectRatio: "16 / 10"
          }}>
                <img src={story.image} data-wvc-srcset={story.srcset} data-wvc-sizes={story.sizes} alt={story.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, hsl(215 80% 20% / 0.2) 0%, hsl(215 80% 20% / 0.05) 40%, hsl(215 80% 20% / 0.4) 100%)"
            }} />
                <span className="absolute top-6 left-6 text-xs font-medium uppercase" style={{
              letterSpacing: "0.22em",
              color: "var(--primary-foreground)"
            }}>
                  {story.area}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-6 md:p-8">
                <h3 className="font-default font-medium mb-4" style={{
              fontSize: "clamp(1.25rem, 1.8vw, 1.5rem)",
              lineHeight: 1.2,
              letterSpacing: "-0.018em"
            }}>
                  {story.title}
                </h3>
                <p className="font-default flex-1" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.6,
              color: "var(--muted-foreground)"
            }}>
                  {story.summary}
                </p>

                <div className="mt-8 pt-6 flex items-center justify-between gap-4 border-t" style={{
              borderColor: "var(--border)"
            }}>
                  <span className="text-sm font-semibold" style={{
                color: "var(--foreground)"
              }}>
                    {story.partner}
                  </span>
                  <Button asChild variant="ghost" size="sm" className="h-auto px-2 py-1 gap-1.5 bg-transparent hover:bg-transparent text-primary hover:text-primary">
                    <Link to={caseStudyRoutes[story.title.trim()] || "/SuccessStoriesPage"} className="group/link inline-flex items-center">
                      <span>Saber Mais</span>
                      <ArrowUpRight className="size-4 transition-transform duration-300 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" strokeWidth={1.25} />
                    </Link>
                  </Button>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}